import React, {Component} from 'react';
import {connect} from 'react-redux';
import {sumBy, filter} from 'lodash';
import {reduxForm, FieldArray, formValueSelector} from 'redux-form';
import {Card, Table, Form, Loader, Button, Icon, Dimmer} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {ordersStatus} from '../../../common/dictionaries/accessories';
import {QUALITY_ASSURANCE_ORDERS_FORM} from '../../../common/forms';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {downloadFile} from '../../../common/util/file';
import PartsAssignmentTableItems from './tableItems';
import './parts.scss';

class PartsAssignment extends Component {
  constructor(props) {
    super(props);
    this.renderTable = this.renderTable.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onGenerateReportClick = this.onGenerateReportClick.bind(this);
  }

  componentDidMount() {
    const {order, permissions} = this.props;
    if (
      !hasAccessPermission(
        permissions,
        resources.QualityAssuranceOrders,
        scopes.Create
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    this.props.fetchQualityAssuranceOrder(order);
    this.props.fetchPartsAvailable();
    this.props.fetchPartsForQualityAssuranceOrder(this.props.order);
  }

  onCancelClick() {
    this.props.goBack();
  }

  onGenerateReportClick() {
    const {order} = this.props;
    const baseUrl = process.env.REP_API_URL;
    const fileUrl = `${baseUrl}/quality-assurance/orders/${order}/parts/document`;
    downloadFile(fileUrl);
  }

  addItem(fields) {
    const allItems = fields.getAll();
    const itemsSaved = filter(allItems, {'itemSaved': true});
    if (allItems.length !== itemsSaved.length) {
      this.props.addMessageBoxError(
        'Llene todos los campos requeridos antes de agregar un nuevo item'
      );
      return;
    }
    fields.push({});
  }

  renderTotals() {
    const {parts, orderStatus} = this.props;
    const totalAmount = sumBy(parts, 'totalPrice');

    if (!parts.length) {
      return;
    }

    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='left' colSpan={2}>
          <span>TOTAL</span>
        </Table.Cell>
        <Table.Cell textAlign='right' className='qty-column'>
          <span>{sumBy(parts, 'quantity')}</span>
        </Table.Cell>
        <Table.Cell textAlign='center' />
        <Table.Cell textAlign='right'>
          <span>
            {'$'}
            {getNumericValue(totalAmount, 2)}
          </span>
        </Table.Cell>
        {orderStatus && orderStatus === ordersStatus.assigned_technicians && (
          <Table.Cell textAlign='center' />
        )}
      </Table.Row>
    );
  }

  renderTable({fields}) {
    const {orderStatus, order} = this.props;
    return (
      <div>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row textAlign='center'>
              <Table.HeaderCell className='part-code-column'>
                Parte
              </Table.HeaderCell>
              <Table.HeaderCell>Stock (On Hand)</Table.HeaderCell>
              <Table.HeaderCell className='qty-column'>Cant.</Table.HeaderCell>
              <Table.HeaderCell>Precio Unitario</Table.HeaderCell>
              <Table.HeaderCell>Precio Total</Table.HeaderCell>
              {orderStatus &&
                orderStatus === ordersStatus.assigned_technicians && (
                <Table.HeaderCell>Acciones</Table.HeaderCell>
              )}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            <PartsAssignmentTableItems fields={fields} order={order} />
            {this.renderTotals()}
          </Table.Body>
        </Table>

        {orderStatus && orderStatus === ordersStatus.assigned_technicians && (
          <div className='addItem' onClick={() => this.addItem(fields)}>
            <Icon name='add' />
            <strong>AGREGAR REGISTRO</strong>
          </div>
        )}
      </div>
    );
  }

  renderLoader() {
    const {savingItem} = this.props;
    if (savingItem) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Procesando' />
        </Dimmer>
      );
    }
  }

  render() {
    const {order, loading, savingItem, parts} = this.props;
    const partsSaved = filter(parts, {'itemSaved': true});

    return (
      <div className='parts-assignment'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick} />
              <h2>Asignación de partes para la orden: {order}</h2>
              <div className='title-bar-actions'>
                <Button
                  disabled={loading || savingItem}
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </Button>
                <Button
                  disabled={loading || savingItem || !partsSaved.length}
                  primary
                  onClick={this.onGenerateReportClick}
                >
                  Generar Reporte
                </Button>
              </div>
            </div>
          </div>
        </Card>

        <Card raised fluid>
          {this.renderLoader()}
          <Form className='primary-content'>
            <FieldArray name='parts' component={this.renderTable} />
          </Form>
        </Card>
      </div>
    );
  }
}

export {PartsAssignment};

const form = reduxForm({
  'form': QUALITY_ASSURANCE_ORDERS_FORM.name,
})(PartsAssignment);

const mapStateToProps = (state, ownProps) => {
  const formValues = formValueSelector(QUALITY_ASSURANCE_ORDERS_FORM.name);
  const parts = formValues(state, 'parts');

  return {
    'order': ownProps.params.orderNumber,
    parts,
    'orderStatus': state.form.qualityAssuranceOrders.values.status,
    'loading': state.form.qualityAssuranceOrders.loading,
    'savingItem': state.form.qualityAssuranceOrders.savingItem,
    'loadingParts': state.partsAssignmentInQualityAssuranceOrders.loadingParts,
    'partsList': state.partsAssignmentInQualityAssuranceOrders.partsList,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'goBack': ownProps.history.goBack,
  };
};

const {
  withRouter,
  fetchQualityAssuranceOrder,
  fetchPartsAvailable,
  fetchPartsForQualityAssuranceOrder,
  addMessageBoxError,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchQualityAssuranceOrder,
  fetchPartsAvailable,
  fetchPartsForQualityAssuranceOrder,
  addMessageBoxError,
})(form));
